module.exports = __webpack_public_path__ + "media/images/Cafod-Logo-1c8b14de7bb934cfd69c9717471c28d4.png";